import { Form, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import FormWrapper from './FormWrapper';

const { Dragger } = Upload;

const uploadProps: UploadProps = {
    name: 'file',
    multiple: true,
    beforeUpload: () => false,
};

export default function LocalUploadConfigForm() {
    return (
        <FormWrapper>
            <Form.Item
                name={['configuration', 'files']}
                label="Upload Files"
                rules={[{ required: true, message: 'Please upload at least one file' }]}
                valuePropName="fileList"
                getValueFromEvent={e => {
                    if (Array.isArray(e)) {
                        return e;
                    }
                    return e?.fileList;
                }}
            >
                <Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">
                        Support for single or multiple file uploads. Accepted formats: PDF, TXT, CSV, JSON, XML
                    </p>
                </Dragger>
            </Form.Item>
        </FormWrapper>
    );
}
